import { render } from "./TheHot.vue?vue&type=template&id=af1d7cf2&scoped=true&ts=true"
import script from "./TheHot.vue?vue&type=script&lang=ts"
export * from "./TheHot.vue?vue&type=script&lang=ts"

import "./TheHot.vue?vue&type=style&index=0&id=af1d7cf2&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af1d7cf2"]])

export default __exports__